import { Component } from "preact";
import { route } from "preact-router";

export default class Redirect extends Component {
  componentWillMount() {
    const locale = this.props.locale;
    const to = this.props.to.replace(":locale", locale);
    route(to, true);
  }

  render() {
    return null;
  }
}
